import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
 const [user, setUser] = useState(() => {
 const u = localStorage.getItem("tt_user");
 return u ? JSON.parse(u) : null;
 });
 const [loading, setLoading] = useState(true);

 useEffect(() => {
 const token = localStorage.getItem("tt_token");
 if (!token) { setLoading(false); return; }
 api.get("/auth/me")
.then(({ data }) => { setUser(data); localStorage.setItem("tt_user", JSON.stringify(data)); })
.catch(() => { localStorage.removeItem("tt_token"); localStorage.removeItem("tt_user"); setUser(null); })
.finally(() => setLoading(false));
 }, []);

 const login = async (email, password) => {
 const { data } = await api.post("/auth/login", { email, password });
 localStorage.setItem("tt_token", data.access_token);
 localStorage.setItem("tt_user", JSON.stringify(data.user));
 setUser(data.user);
 return data.user;
 };

 const register = async (name, email, password) => {
 const { data } = await api.post("/auth/register", { name, email, password });
 localStorage.setItem("tt_token", data.access_token);
 localStorage.setItem("tt_user", JSON.stringify(data.user));
 setUser(data.user);
 return data.user;
 };

 const logout = () => {
 localStorage.removeItem("tt_token");
 localStorage.removeItem("tt_user");
 setUser(null);
 window.location.href = "/";
 };

 const refreshUser = async () => {
 const { data } = await api.get("/auth/me");
 setUser(data);
 localStorage.setItem("tt_user", JSON.stringify(data));
 };

 return (
 <AuthCtx.Provider value={{ user, loading, login, register, logout, refreshUser, refresh: refreshUser }}>
 {children}
 </AuthCtx.Provider>
 );
}

export const useAuth = () => useContext(AuthCtx);
